import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { CircularProgress } from '@mui/material'
import LoadingButton from 'proposals/components/LoadingButton'
import { useTranslation } from 'react-i18next'

interface EditVendorContactDialogProps {
  children: React.ReactNode
  isInitingData: boolean
  isDisabled: boolean
  isLoading: boolean
  onClose: () => void
  onClick: () => void
}

const EditVendorContactDialog: React.FC<EditVendorContactDialogProps> = ({
  children,
  isInitingData,
  onClose,
  isDisabled,
  isLoading,
  onClick
}) => {
  const { t } = useTranslation()

  return (
    <Dialog PaperProps={{ sx: { height: 615 } }} maxWidth="sm" fullWidth open={true} onClose={onClose}>
      <DialogTitle>{t('edit-contact')}</DialogTitle>
      {isInitingData ? (
        <DialogContent>
          <Box sx={{ display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress size={32} />
          </Box>
        </DialogContent>
      ) : (
        <>
          <DialogContent>{children}</DialogContent>
          <DialogActions sx={{ px: 2, pb: 2 }}>
            <Button color="grey" onClick={onClose}>
              {t('cancel')}
            </Button>
            <LoadingButton onClick={onClick} disabled={isDisabled} isLoading={isLoading}>
              {t('edit')}
            </LoadingButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default EditVendorContactDialog
